const MetroidItems = {
    "super-metroid-bomb":{
        "type":"png",
        "content":"metroid3/bombs",
        "nicename": "Super Metroid - Bomb"
    },
    "super-metroid-charge":{
        "type":"png",
        "content":"metroid3/charge",
        "nicename": "Super Metroid - Charge"
    },
    "super-metroid-draygon":{
        "type":"png",
        "content":"metroid3/draygon",
        "nicename": "Super Metroid - Boss - Draygon"
    },
    "super-metroid-etank":{
        "type":"png",
        "content":"metroid3/etank",
        "nicename": "Super Metroid - ETank"
    },
    "super-metroid-grappling":{
        "type":"png",
        "content":"metroid3/grappling",
        "nicename": "Super Metroid - Grappling"
    },
    "super-metroid-ice-beam":{
        "type":"png",
        "content":"metroid3/ice",
        "nicename": "Super Metroid - Ice Beam"
    },
    "super-metroid-kraid":{
        "type":"png",
        "content":"metroid3/kraid",
        "nicename": "Super Metroid - Boss - Kraid"
    },
    "super-metroid-missile":{
        "type":"png",
        "content":"metroid3/missile",
        "nicename": "Super Metroid - Missile"
    },
    "super-metroid-morph":{
        "type":"png",
        "content":"metroid3/morph",
        "nicename": "Super Metroid - MorphBall"
    },
    "super-metroid-phantoon":{
        "type":"png",
        "content":"metroid3/phantoon",
        "nicename": "Super Metroid - Boss - Phantoon"
    },
    "super-metroid-plasma":{
        "type":"png",
        "content":"metroid3/plasma",
        "nicename": "Super Metroid - Plasma Beam"
    },
    "super-metroid-powerbomb":{
        "type":"png",
        "content":"metroid3/powerbomb",
        "nicename": "Super Metroid - Powerbomb"
    },
    "super-metroid-ridley":{
        "type":"png",
        "content":"metroid3/ridley",
        "nicename": "Super Metroid - Boss - Ridley"
    },
    "super-metroid-rtank":{
        "type":"png",
        "content":"metroid3/rtank",
        "nicename": "Super Metroid - RTank"
    },
    "super-metroid-screw":{
        "type":"png",
        "content":"metroid3/screw",
        "nicename": "Super Metroid - Screwattack"
    },
    "super-metroid-space":{
        "type":"png",
        "content":"metroid3/space",
        "nicename": "Super Metroid - Space"
    },
    "super-metroid-spazer":{
        "type":"png",
        "content":"metroid3/spazer",
        "nicename": "Super Metroid - Spazer Beam"
    },
    "super-metroid-speed":{
        "type":"png",
        "content":"metroid3/speed",
        "nicename": "Super Metroid - Speed"
    },
    "super-metroid-springball":{
        "type":"png",
        "content":"metroid3/springball",
        "nicename": "Super Metroid - Springball"
    },
    "super-metroid-supermissile":{
        "type":"png",
        "content":"metroid3/supermissile",
        "nicename": "Super Metroid - Supermissile"
    },
    "super-metroid-varia":{
        "type":"png",
        "content":"metroid3/varia",
        "nicename": "Super Metroid - Varia Suit"
    },
    "super-metroid-wave":{
        "type":"png",
        "content":"metroid3/wave",
        "nicename": "Super Metroid - Wave Beam"
    },
    "super-metroid-xray":{
        "type":"png",
        "content":"metroid3/xray",
        "nicename": "Super Metroid - Xray"
    },
}
const MetroidSets = {
    'super-metroid-all' : ',super-metroid-draygon,super-metroid-kraid,super-metroid-phantoon,super-metroid-ridley,|,super-metroid-charge,super-metroid-ice-beam,,super-metroid-spazer,super-metroid-wave,super-metroid-plasma,|,super-metroid-grappling,super-metroid-speed,super-metroid-varia,super-metroid-xray,|,super-metroid-rtank,super-metroid-etank,super-metroid-missile,super-metroid-supermissile,|,super-metroid-morph,super-metroid-bomb,super-metroid-powerbomb,super-metroid-springball'
}
export {MetroidItems, MetroidSets};